import { TranslationKeyMap } from '../../coaching-insight/coaching-insight.i18n';
import { Opportunity } from '../general';

import { OpportunityType } from './opportunity-type.model';
import { OpportunityView } from './opportunity-view.model';

// TODO remove export after OALegendComponent is refactored
export const opportunityTypeGoalBgColourMap: {
    [key in OpportunityType]: string;
} = {
    [OpportunityType.PENDING]: '#ccc',
    [OpportunityType.COMPONENT]: '#fff', // component-goal-container
    [OpportunityType.ACTIVE]: '',
    [OpportunityType.CLOSED_STILL_OPP]: '#000',
    [OpportunityType.NO_GOAL]: '#ce2521',
    [OpportunityType.CLOSED_NOT_OPP]: '#137e0f',
    [OpportunityType.MISSED]: '#d17300',
    [OpportunityType.MISSED_EXPIRED]: '#ce2521',
};

// TODO remove export after OALegendComponent is refactored
export const opportunityTypeGoalColourMap: {
    [key in OpportunityType]: string;
} = {
    [OpportunityType.PENDING]: '#fff',
    [OpportunityType.COMPONENT]: '#4c4c4c', // component-goal-container
    [OpportunityType.ACTIVE]: '#fff',
    [OpportunityType.CLOSED_STILL_OPP]: '#fff',
    [OpportunityType.NO_GOAL]: '#fff',
    [OpportunityType.CLOSED_NOT_OPP]: '#fff',
    [OpportunityType.MISSED]: '#fff',
    [OpportunityType.MISSED_EXPIRED]: '#fff',
};

// TODO remove export after OALegendComponent is refactored
export const opportunityTypeIconMap: { [key in OpportunityType]: string } = {
    [OpportunityType.PENDING]: null,
    [OpportunityType.COMPONENT]: null, // component-count
    [OpportunityType.ACTIVE]: 'exclamation', // cmps-exclamation
    [OpportunityType.CLOSED_STILL_OPP]: 'exclamation', // cmps-exclamation
    [OpportunityType.NO_GOAL]: 'exclamation', // cmps-exclamation
    [OpportunityType.CLOSED_NOT_OPP]: 'check', // cmps-checked
    [OpportunityType.MISSED]: 'oa-missed-opp',
    [OpportunityType.MISSED_EXPIRED]: 'expired-goal',
};

// TODO remove export after OALegendComponent is refactored
export const opportunityTypeSymbolMap: { [key in OpportunityType]: string } = {
    [OpportunityType.PENDING]: 'P',
    [OpportunityType.COMPONENT]: 'C',
    [OpportunityType.ACTIVE]: null,
    [OpportunityType.CLOSED_STILL_OPP]: null,
    [OpportunityType.NO_GOAL]: null,
    [OpportunityType.CLOSED_NOT_OPP]: null,
    [OpportunityType.MISSED]: null,
    [OpportunityType.MISSED_EXPIRED]: null,
};

export function adjustOpportunity(
    opp: Opportunity,
    oppType: OpportunityType,
    next: OpportunityView,
): void {
    next.goalColour = opportunityTypeGoalBgColourMap[oppType];
    next.goalLabelColour = opportunityTypeGoalColourMap[oppType];
    next.goalIcon = opportunityTypeIconMap[oppType];

    if (oppType === OpportunityType.ACTIVE) {
        // TODO post-refactor goal-score.component.ts:getGoalValue
        if (opp.actual != null && opp.percentToGoal != null) {
            next.goalColour = opp.goalThresholdColour;
        }

        if (opp.actual == null || opp.percentToGoal == null) {
            // TODO post-refactor goal-score.component.ts:getGoalValue
            next.goalColour = '#ccc';

            // TODO post-refactor goal-score.component.html
            next.goalLabel = TranslationKeyMap._842_N_A;
        }
    }

    // TODO post-refactor goal-score.component.html
    if (
        oppType === OpportunityType.PENDING ||
        oppType === OpportunityType.COMPONENT
    ) {
        next.goalLabel = opportunityTypeSymbolMap[oppType];
    }

    if (oppType === OpportunityType.COMPONENT) {
        next.goalBorderColour = next.goalLabelColour;
        next.goalBadgeColour = next.goalLabelColour;
        next.goalBadgeLabel = `${next.numCoachedComponents}`;
        next.goalBadgeLabelColour = next.goalColour;
    }

    if (
        oppType !== OpportunityType.PENDING &&
        oppType !== OpportunityType.COMPONENT &&
        oppType !== OpportunityType.ACTIVE
    ) {
        // unset these so the icon will show
        next.goalLabel = null;
        next.percentToGoal = null;
    }

    // TODO post-refactor metric-button.component.html
    if (opp.percentToTarget >= 999) {
        next.targetLabel = '999+';
    }
    if (opp.percentToTarget == null) {
        next.targetLabel = TranslationKeyMap._842_N_A;
    }
}
